export const MAX_ALLOWED_BUTTONS = 2;
